<div class="toolbar">
  <button class="toolbarButton" matButton="text" (click)="backToEntityLoops()">
    <span>
      <mat-icon class="size-16">keyboard_backspace</mat-icon>
      <label class="buttonLabel">Back to loops</label>
    </span>
  </button>
  @if (canChangeProducts()) {
    <button class="toolbarButton" matButton="text" (click)="changeProducts()">
      <span></span>
      <mat-icon class="size-16">refresh</mat-icon>
      <label class="buttonLabel">Pick a Different Product</label>
    </button>
  }
  <span class="spacer"></span>
  <button class="toolbarButton" [disabled]="!canSave()" matButton="text" (click)="saveConfiguration()">
    <span></span>
    <mat-icon class="size-16">save</mat-icon>
    <label class="buttonLabel">Save Changes</label>
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
@if (dataLoaded()) {
  <div class="content">
    @if ((selections()?.length || 0) > 0 && (selectedUnits()?.length || 0) > 0) {
      <div class="selectionsWrapper">
        <app-unit-details-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" [entityLines]="affectedLines()" [selectedUnits]="selectedUnits()" (selectionChanged)="selectionChanged($event)"
        (tagsUpdated)="updateTags($event)"></app-unit-details-section>
        @if (isSingleUnitMode()) {
          <app-ratings-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-ratings-section>
        }
        <app-indoor-air-quality-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-indoor-air-quality-section>
        @if (ratingUnitData()) {
          <app-performance-inputs-section [unitData]="ratingUnitData()" (selectionChange)="updateUnitRatings($event)" (targetChange)="targetLoadChanged()"></app-performance-inputs-section>
        }
        @if (isSingleUnitMode() && ratingResponse()) {
          <app-performance-results-section [isMetric]="selectedLoop().detail.metric" [response]="ratingResponse()"></app-performance-results-section>
        }
        @if (!isModularProductSelected()) {
          <app-mechanical-connections-section [handArrangementImagePath]="handArrangementImagePath()" [invalidEntityNames]="invalidEntities()" [selections]="selections()"
          (selectionChanged)="selectionChanged($event)"></app-mechanical-connections-section>
        }
        @if (isModularProductSelected()) {
          <app-modular-mechanical-connections-section [handArrangementImagePath]="handArrangementImagePath()" [pipeDetailImagePath]="pipeDetailImagePath()" [invalidEntityNames]="invalidEntities()"
          [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-modular-mechanical-connections-section>
        }
        <app-controls-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-controls-section>
        <app-coil-options-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-coil-options-section>
        <app-primary-valve-package-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-primary-valve-package-section>
        <app-secondary-valve-package-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-secondary-valve-package-section>
        @if (!isVerticalFloorA()) {
          <app-cabinet-features-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-cabinet-features-section>
        }
        @if (isVerticalFloorA()) {
          <app-vertical-floor-a-cabinet-features-section [invalidEntityNames]="invalidEntities()" [selections]="selections()" (selectionChanged)="selectionChanged($event)"></app-vertical-floor-a-cabinet-features-section>
        }
      </div>
    }
    <div class="rightPanel">
      @if (getProductImage()) {
        <div class="imageContainer">
          <img class="modelImage" [src]="getProductImage()"/>
        </div>
      }
      @if (messages() && messages().length > 0) {
        <button matButton="elevated" class="messagesButton" (click)="showMessages()">
          Messages
        </button>
      }
      @if (showSkusAndPrices()) {
        <app-skus-and-pricing-section [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrs()" [configurationLeadTime]="configurationLeadTime()" [entityLeadTime]="entityLeadTime()"
        (sfrFlagChanged)="sfrFlagChanged($event)"></app-skus-and-pricing-section>
      }
    </div>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
